<ui-modal
  class="fixings-modal"
  [isOpened]="showFixings"
  modalTitle="Fixings"
  size="xl"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="body">
    <form [formGroup]="fixingForm" autocomplete="off">
      <div>
        <div>
          <div class="title-container">
            <label class="title-container__label">
              Fixings for:
              <app-selector
                [isSearch]="true"
                formControlName="currencyPairs"
                [passedItems]="currencyPairs"
              >
              </app-selector>
            </label>
            <label class="title-container__label">
              Fixing Source:
              <app-selector
                [isSearch]="true"
                formControlName="fixingSources"
                [passedItems]="fixingSourcesLongNames"
              >
              </app-selector>
            </label>
          </div>
          <div [ngClass]="areTenorsLoading ? 'loading-tenors' : 'tenors'">
            @if (areTenorsLoading) {
              <loading-spinner />
            } @else {
              <div class="table-info-container">
                <form [formGroup]="fixingForm">
                  <div #divToScroll class="table-container">
                    <table ui-table>
                      <thead>
                        <tr>
                          <th class="date">Date</th>
                          <th class="value">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container formArrayName="fixings">
                          <tr
                            tabindex="0"
                            *ngFor="let item of returnDates(); let i = index"
                            (mousedown)="selectedDateIndex = i"
                            [ngClass]="{
                              'selected-row': selectedDateIndex === i
                            }"
                          >
                            <ng-container [formGroupName]="i">
                              <td>
                                <input
                                  type="text"
                                  [name]="'date#' + (i + 1)"
                                  class="input-cell"
                                  formControlName="date"
                                  [placeholder]="'Date #' + (i + 1)"
                                  (input)="onDateChange()"
                                />
                              </td>

                              <td>
                                <div style="display: flex">
                                  <input
                                    type="number"
                                    [name]="'spot#' + (i + 1)"
                                    class="input-cell"
                                    formControlName="spot"
                                  />
                                  @if (item.get('canBeRemoved')) {
                                    <button
                                      class="ui-button primary remove-fixing"
                                      (click)="removeFixing(i)"
                                    >
                                      x
                                    </button>
                                  }
                                </div>
                              </td>
                            </ng-container>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </form>
                <div class="bottom-table-add">
                  <div>
                    <span class="add-text-container" (click)="addNewDate()">
                      <label class="Page-1">+</label>
                      <label class="add-text">Add Date</label></span
                    >
                  </div>
                </div>
                @if (fixingForm.hasError('duplicateDates', 'fixings')) {
                  <clr-control-error>
                    Duplicate dates are not allowed.
                  </clr-control-error>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="hr"></div>
  <div class="modal-footer">
    <div class="saving">
      <loading-spinner
        *ngIf="processingInfo === 'Processing'"
      ></loading-spinner>
      <div
        *ngIf="processingInfo === 'Saved' || processingInfo === 'Failed'"
        [ngClass]="processingInfo === 'Saved' ? 'success' : 'failed'"
      >
        {{ processingInfo }}
      </div>
    </div>

    <button type="button" (click)="modalChanged(false)" class="ui-button">
      Cancel
    </button>

    <button
      type="button"
      (click)="onSaveFixingChanges()"
      class="ui-button primary"
      [disabled]="!fixingForm.get('fixings').valid"
    >
      Save
    </button>
  </div>
</ui-modal>
